import { memo, useEffect, useRef, useState } from "react";
import {Button, Modal} from "antd";
import Cropper from "cropperjs";
import "./ImageCropper.scss";
import "cropperjs/dist/cropper.css";
import EditorBar from "./EditorBar";
import { ImgCropper } from "../../types";
import { IMAGE_MIME_TYPES } from "../../constants";
import { t } from "i18next";

export interface ImgCropperType {}

export interface ImageCropperProps {
  imgCropper: ImgCropper;
  onClose: (x?: any) => void;
}

const ImageCropper = memo(({ imgCropper, onClose }: ImageCropperProps) => {
  const imgRef = useRef<HTMLImageElement>(null);
  const editorBarRef = useRef<HTMLImageElement>(null);
  const [cropper, setCropper] = useState<Cropper>();

  const handleOk = () => {
    cropper!.crop();
    // @ts-ignore
    const croppedCanvas = editorBarRef.current.getCroppedCanvas(); // 获取被裁剪后的canvas
    // @ts-ignore
    const isCircleCropper: boolean = editorBarRef.current.isCircleCropper;
    // @ts-ignore
    const croppeAspectRatio: number = editorBarRef.current.croppeAspectRatio;
    const base64 = croppedCanvas.toDataURL(IMAGE_MIME_TYPES.png); // 转换为base64
    const croppedImageSize = {
      ...cropper!.getData(),
      isCircleCropper,
      croppeAspectRatio,
    };
    onClose({
      element: imgCropper.element,
      croppedImage: { src: base64, croppedCanvas, croppedImageSize },
    });
  };

  const handleCancel = () => {
    onClose();
  };

  useEffect(() => {
    const cropper = new Cropper(imgRef.current!, {
      // autoCropArea: 1,

      ready() {
        setCropper(cropper);
      },
    });

    return () => {
      cropper!.destroy();
    };
  }, []);

  return (
      <div className="image-cropper">
        <Modal
            width={532}
            centered
            getContainer={false}
            open
            okText={'Done'}
            closable={false}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={
              <div style={{height:'38px',marginTop:'36px',zIndex:'9999'}}>
                <div className={'flex-row-vertical-center'} style={{justifyContent:"flex-end"}}>
                  <span onClick={handleCancel} style={{minWidth: '128px', height: '38px',lineHeight:'38px', display:'block',textAlign:'center'}}
                       className='button-border-gray-style font-size-14 font-family-medium flex-center'>{t("Cancel")}</span>
                  <span onClick={handleOk} style={{minWidth: '128px', height: '38px',lineHeight:'38px', display:'block',textAlign:'center'}}
                       className='button-solid-style font-size-14 font-family-medium ml-12 flex-center'>{t("Done")}</span>
                </div>

              </div>
            }
        >
          <div className="img-container">
            <img
                ref={imgRef}
                src={imgCropper.image?.src}
                alt="img"
                // style={{ maxWidth: "100%" }}
            />
          </div>
          {cropper && (
              <EditorBar
                  cropper={cropper}
                  ref={editorBarRef}
                  croppedImageSize={imgCropper.element?.croppedImageSize}
              />
          )}
        </Modal>
      </div>
  );
});

export default ImageCropper;
